import { SlidersHorizontal } from "lucide-react";
import { useFilter } from "./FilterContext";
import { useTranslation } from "@/packages/utils";

export function FilterTrigger({
  ref,
  ...props
}: React.ComponentPropsWithoutRef<"button"> & {
  ref?: React.Ref<HTMLButtonElement>;
}) {
  const { t } = useTranslation("common");
  const { isOpen, filters } = useFilter();

  return (
    <button
      ref={ref}
      {...props}
      className={`flex items-center gap-1.5 rounded-[6px] px-2.5 py-1.5 text-[13px] font-medium transition-colors cursor-pointer ${
        isOpen || filters.length > 0
          ? "text-primary bg-card-hover"
          : "text-secondary hover:text-primary hover:bg-card-hover"
      }`}
    >
      <SlidersHorizontal className="h-3.5 w-3.5" strokeWidth={1.8} />
      {t("labels.filters")}
      {filters.length > 0 && (
        <span className="ml-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-accent text-[10px] font-semibold text-white px-1">
          {filters.length}
        </span>
      )}
    </button>
  );
}
